<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid && !existsSupplier" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus @input="searchSupplier(form.name, isAdd)" :placeholder='$t("suppliers.name_placeholder")' :danger="($v.form.name.$invalid && supplierIsEmpty) || existsSupplier" :danger-text="existsSupplier ? $t('suppliers.supplier_already_exists') : $t('validation.required', { attribute: $t('suppliers.name') })" v-model="form.name" :label='$t("suppliers.name")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("suppliers.business_name_placeholder")' :danger="$v.form.business_name.$invalid && $v.form.business_name.$model" :danger-text="$t('validation.required', { attribute: $t('suppliers.business_name') })" v-model="form.business_name" :label='$t("suppliers.business_name")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("suppliers.phone_placeholder")' :danger="$v.form.phone.$invalid && $v.form.phone.$model" :danger-text="$t('validation.required', { attribute: $t('suppliers.phone') })" v-model="form.phone" :label='$t("suppliers.phone")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("suppliers.email_placeholder")' :danger="$v.form.email.$invalid && $v.form.email.$model" :danger-text="$t('validation.required', { attribute: $t('suppliers.email') })" v-model="form.email" :label='$t("suppliers.email")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("suppliers.rfc_placeholder")' :danger="$v.form.rfc.$invalid && $v.form.rfc.$model" :danger-text="$t('validation.required', { attribute: $t('suppliers.rfc') })" v-model="form.rfc" :label='$t("suppliers.rfc")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("suppliers.address_placeholder")' :danger="$v.form.address.$invalid && $v.form.address.$model" :danger-text="$t('validation.required', { attribute: $t('suppliers.address') })" v-model="form.address" :label='$t("customers.address")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
         b {{ $t('suppliers.has_credit') }}
         vm-switch(v-model="form.has_credit")
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, numeric, email, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Suppliers')

export default {
  name: 'ModalSuppliers',
  mixins: [ModalMixin1],
  data: () => ({
    existsSupplier: false,
    suppliersFound: [],
    supplierIsEmpty: false,
    defaultSupplier: ''
  }),
  validations () {
    return {
      form: {
        name: {
          required
        },
        repeat: {
          required: requiredIf(() => this.existsSupplier)
        },
        business_name: {
          required
        },
        phone: {
          numeric,
          required
        },
        email: {
          email,
          required
        },
        rfc: {
          required
        },
        address: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog', 'suppliers'])
  },
  watch: {
    isModalVisible () {
      if (this.isModalVisible) {
        this.supplierIsEmpty = false
        this.existsSupplier = false
        this.defaultSupplier = this.form.name
      }
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      if (!this.existsSupplier || !this.isAdd) {
        this.isAdd ? this.addRecord(this.form) : this.editRecord(this.form)
      }
    },
    searchSupplier (supplier, add) {
      if (add) {
        this.suppliersFound = this.suppliers.find(item => item.name.toUpperCase() === supplier.toUpperCase())
      } else {
        this.suppliersFound = this.suppliers.find(item => item.name.toUpperCase() === supplier.toUpperCase() && item.name.toUpperCase() !== this.defaultSupplier.toUpperCase())
      }
      this.existsSupplier = !!this.suppliersFound
      this.supplierIsEmpty = !this.form.name.trim().length
    }
  }
}
</script>
